/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebox_Logout1Inputs */

const en_profilebox_logout1 = /** @type {(inputs: Profilebox_Logout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const de_profilebox_logout1 = /** @type {(inputs: Profilebox_Logout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Profilebox_Logout1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebox_logout1 = /** @type {((inputs?: Profilebox_Logout1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebox_Logout1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebox_logout1(inputs)
	return de_profilebox_logout1(inputs)
});
export { profilebox_logout1 as "profileBox_logout" }